import { motion } from "framer-motion";
import Mascot from "@/components/Mascot";

const CHAPTERS = [
  {
    num: "01",
    title: "Zero engine. Pure gravity.",
    text: "You control your own speed on 1.25 km of stainless-steel track.",
  },
  {
    num: "02",
    title: "No loadshedding here.",
    text: "Solar power keeps the fun running, even when the city's lights go out.",
  },
  {
    num: "03",
    title: "Safety comes first.",
    text: "Riders start from as young as 3 years old with an adult.",
  },
  {
    num: "04",
    title: "Free Wi-Fi.",
    text: "Stream the slow-mo replays from the track — fast, free Wi-Fi for everyone.",
  },
  {
    num: "05",
    title: "No parking fees.",
    text: "Parking right at the entrance, free for the whole crew, all day long.",
  },
  {
    num: "06",
    title: "No entrance fee.",
    text: "Walk in for free — you only pay for the rides you want.",
  },
];

export default function Manifesto() {
  return (
    <section id="experience" className="mx-auto max-w-7xl px-4 py-24 sm:px-6" data-testid="manifesto-section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7 }}
      >
        <h2 className="mt-3 max-w-3xl text-4xl leading-tight sm:text-5xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }}>
          WHY CAPE TOWN <span className="text-[#c87700]">RIDES</span> WITH US
        </h2>
      </motion.div>

      <div className="mt-14">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.05 }}
            className="grid items-start gap-6 border-t border-[#241c0d]/12 py-10 md:grid-cols-[220px_1fr_1.4fr] md:gap-10"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <span className="text-stroke-green text-7xl leading-none md:text-8xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }}>{c.num}</span>
            <h3 className="text-3xl leading-tight text-[#f8b818] md:text-4xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }}>{c.title}</h3>
            <p className="max-w-xl text-base font-semibold leading-relaxed text-[#8a7b5e]">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
